import { Link } from 'react-router-dom';
import classNames from 'classnames';
import { Provider } from '@vgtv/api-client';

import { config } from '../../config';
import { ReactComponent as LogoVGTV } from '../../icons/VGTV-logo.svg';
import { ReactComponent as LogoAB } from '../../icons/AB-logo.svg';

import type { FC } from 'react';

import * as styles from './Logo.module.scss';

type Props = {
  className?: string;
};

export const Logo: FC<Props> = ({ className }) => {
  return config.provider === Provider.VGTV ? (
    <Link to="/" className={classNames(styles.container, className)}>
      <LogoVGTV className={styles.logo} />
    </Link>
  ) : (
    <a
      href="https://www.aftonbladet.se/"
      className={classNames(styles.container, className)}
    >
      <LogoAB className={styles.logo} />
    </a>
  );
};
